import { takeEvery } from 'redux-saga/effects'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

const makeDocumentListChannelData = (onChannelData) => {
  return function * handleDesksChannelData (action) {
    const { channel, actionName, elementName, data } = action.payload

    yield onChannelData({ channel, actionName, elementName, data })
  }
}

export default function * documentListChannelData (onChannelData) {
  const channelData = makeDocumentListChannelData(onChannelData)

  yield takeEvery(CHANNEL_DATA, channelData)
}